<template>
  <div class="main">
    <div class="banner" :style=" 'background-image: url(' + this.banner + ');'">
      <p class="bannerp1">{{bannertext1}}</p>
      <p class="bannerp2">{{bannertext2}}</p>
      <!-- <div class="banner">  -->
    </div>
    <div class="about">
      <div class="about1">
        <div class="about1-2">
          <p
            class="aboutp1 one"
            style="margin: 0.9rem 0.4rem"
          >{{ischinese == "cn" ?this.about.title:this.about.title_en}}</p>
          <p class="aboutp1" style=" margin:0 0.4rem 0.3rem;">{{aboutp1}}</p>
          <div class="servicesp1">{{this.strs[0]}}</div>
          <div class="servicesp2">{{this.strs[1]}}</div>
          <p class="aboutp1" style=" margin:0 0.4rem 0.3rem;">{{aboutp2}}</p>
          <div class="servicesp2">{{ischinese == "cn" ?this.about.mission:this.about.mission_en}}</div>
          <p class="aboutp1" style=" margin:0 0.4rem 0.3rem;">{{aboutp3}}</p>
          <div
            class="servicesp22"
            style=" margin: 0 0.4rem;"
          >{{ischinese == "cn" ?this.about.vision:this.about.vision_en}}</div>
        </div>
      </div>
    </div>
  </div>
</template> 

</template>
<script>
export default {
  data() {
    return {
      banner: "",
      currentPage4: 1,
      about: {
        mission: "",
        overview: "",
        vision: ""
      },
      strs: [],
      ischinese: "cn",
      aboutp1: "业务概览",
      aboutp2: "大树的使命",
      aboutp3: "大树愿景",
      bannertext1: "中国领先的",
      bannertext2: "跨境品牌管理公司"
    };
  },
  created() {
    this.ischinese = window.localStorage.getItem("ischinese") || "cn";
    if (this.ischinese == "en") {
      this.bannertext1 = "China's Leading";
      this.bannertext2 = "Cross-border Brand Management Company";
      this.aboutp1 = "Business Overview";
      this.aboutp2 = "The Mission of Dashu";
      this.aboutp3 = "The Vision of Dashu";
    }
    this.$http
      .post("/api/dashu/about/aboutList", {})
      .then(res => {
        // console.log(res.data.data)
        var code = res.data.code;
        if (code === 0) {
          if (this.ischinese == "cn") {
            this.about = res.data.data.about;
            //  console.log(this.about)
            var str4 = res.data.data.about.overview;
            var strs4 = str4.split("\n");
            this.strs = strs4;
            // console.log(res.data.data)
            this.banner = res.data.data.banner.mobile_img;
            // console.log(this.banner)
          } else if (this.ischinese == "en") {
            this.about = res.data.data.about;
            //  console.log(this.about)
            var str4 = res.data.data.about.overview_en;
            var strs4 = str4.split("\n");
            this.strs = strs4;
            // console.log(res.data.data)
            this.banner = res.data.data.banner.mobile_img;
            // console.log(this.banner)
          }
        }
      })
      .catch(function(error) {
        //  console.log(error);
      });
  },
  methods: {}
};
</script>
<style scoped>
body {
  position: relative;
  background: white;
}
.banner {
  /* background-image: url('../../assets/dashu/aboutbanner.png'); */
  overflow: hidden !important;
  position: relative;
  background-size: cover;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 10.29rem;
}
.about {
  /* width:1900px; */
  background: white;
}
.about1 {
  background: white;
}
.about1-2 {
  background: white;
}
.aboutp1 {
  font-size: 0.48rem;
  font-weight: bold;
  margin: 0;
}

.one {
  font-size: 0.36rem;
}
.servicesp1,
.servicesp2 {
  color: grey;
  font-size: 0.24rem;
  line-height: 0.4rem;
}
.servicesp1 {
  padding: 0 0.39rem 0.3rem 0.39rem;
}
.servicesp2 {
  padding: 0 0.39rem 0.9rem 0.39rem;
}
.servicesp22 {
  margin: 0 0 1.5rem 0;
  color: grey;
  font-size: 0.24rem;
  line-height: 0.36rem;
  padding-bottom: 45px;
}

.bannerp1 {
  /* position: absolute;
  top: 230px;
  left: 400px; */
  text-align: center;
  font-size: 0.8rem;
  font-weight: bold;
  color: white;
  margin-top: 3.5rem;
}
.bannerp2 {
  /* margin: 0 auto; */
  font-size: 0.5rem;
  line-height: 1.5;
  /* width: 6.7rem; */
  width: 100%;
  /* -webkit-line-clamp: 2; */
  color: white;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/mbPages/mContact.vue